const onFocus = () => {
  const inputs = document.querySelectorAll(
    '.input-group input,.input-group textarea'
  );
  Array.from(inputs).forEach((el) => {
    el.onfocus = () => {
      if (el.value === '') el.parentElement.classList.add('isfocus');
    };
    el.onblur = () => {
      if (el.value === '') el.parentElement.classList.remove('isfocus');
    };
  });
};

function findAncestor(el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

export { onFocus };
